import { PWelcome, PWelcomeNew } from "libs/raas-ui-react-components/src/components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getLiterals } from "./Home.util";
import { useEffect, useState } from 'react';

import { Amplify, Auth, Hub } from 'aws-amplify';
import '@aws-amplify/ui-react/styles.css';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';

import './Home.scss';
import { getPromiseByProvider } from "services/user/user-login-social.service";
declare const window: any;
export default function Home() {

    const navigate = useNavigate();

    const [t/*, i18n*/] = useTranslation("home");

    const literals = getLiterals(t);

    /**
     * @description navigate to register / login
     */
    const handleClick = (destiny: CustomEvent) => {
        destiny?.detail == "sign-up" ? navigate("/register-user") : navigate("/login");
    }

    /**
     * @description navigate to last page
     */
    const handleExitPage = () => {
        navigate(-1);
    }

    const handleLoginSocial = ({ detail }: CustomEvent) => {
        window.dataLayer?.push({
            event: "select_content",
            screen_name: 'welcome',
            screen_class: 'onboarding',
            content_name: 'social_login',
            content_type: detail,
          });
        getPromiseByProvider(detail);
    }

    return (
        <div className="Home">
            <PWelcomeNew
                className="welcome"
                literals={literals}
                onExitPage={handleExitPage}
                onClickButtonPage={handleClick}
                onLoginSocialClicked={handleLoginSocial}
            />
        </div>
    )
}